exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aws-settings-form {\n  border: none;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/forms/components/aws-settings-form/aws-settings-form.component.scss
// module id = ../../../../../src/app/forms/components/aws-settings-form/aws-settings-form.component.scss
// module chunks = 12